/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

// Import styles
import '../styles/main.scss';

import $ from 'jquery';
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import 'slick-carousel';
import SimpleLightbox from 'simplelightbox';
import AOS from 'aos';
import { CountUp } from 'countup.js';

// Legacy flexible-content init (no-ops if .fc-wrapper-legacy is absent)
import './flexible-legacy';

// If you only need specific modules:
// import { Foundation, Accordion, Tabs } from 'foundation-sites';
(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
      
        UIkit.use(Icons);

        AOS.init({
          duration: 1000,
          once: true,
        },
      );


      function hoverCardsInit(){
        // get all elements with data-hover-card
        const hoverCards = document.querySelectorAll('.cards-style--primary');

        hoverCards.forEach(card => {
          // get the height of card-p ( if it exists )
          const cardP = card.querySelector('.hover-panel');
          let cardPHeight = 0;
          if (cardP) {
            cardPHeight = cardP.offsetHeight;
          }
          // set p height to 0 and overflow to hidden
          if (cardP) {
            cardP.style.height = '0';
            cardP.style.overflow = 'hidden';
          }
          // add mouseenter event to card
          card.addEventListener('mouseenter', () => {
            if (cardP) {
              cardP.style.height = cardPHeight + 'px';
            }
          });
          // add mouseleave event to card
          card.addEventListener('mouseleave', () => {
            if (cardP) {
              cardP.style.height = '0';
            }
          });

        });
        
      }

      // Product card (.wc-card) hover panel on touch devices.
      // No :hover on touch, and the card is a link — so the first tap reveals
      // the hover panel (adds .is-touched) and a second tap follows the link.
      function productCardTapInit(){
        if (!window.matchMedia('(hover: none)').matches) return; // touch-primary only

        document.querySelectorAll('.wc-card').forEach(function(card){
          if (!card.querySelector('.wc-card-hover')) return; // no panel, nothing to reveal

          card.addEventListener('click', function(e){
            if (!card.classList.contains('is-touched')) {
              e.preventDefault();
              document.querySelectorAll('.wc-card.is-touched').forEach(function(c){
                if (c !== card) c.classList.remove('is-touched');
              });
              card.classList.add('is-touched');
            }
            // already revealed → let the tap follow the product link
          });
        });

        // Tapping outside any card collapses the revealed panels.
        document.addEventListener('click', function(e){
          if (!e.target.closest('.wc-card')) {
            document.querySelectorAll('.wc-card.is-touched').forEach(function(c){
              c.classList.remove('is-touched');
            });
          }
        });
      }

      // Primary nav: keep open menu columns equal height. Panels render at
      // natural content height (the Customizer's Additional CSS overrides the
      // stylesheet's bottom-pinning with `bottom: auto` on desktop), so on
      // every hover/focus change measure the open panels and set them all to
      // the tallest one's height. Each flyout's top:-3px offsets its parent's
      // 3px border-top, so panel tops align and equal heights align bottoms.
      function primaryNavHeightSync(){
        var nav = document.getElementById('primary-navigation');
        if (!nav) return;

        var pending = false;

        function openRoot(){
          return nav.querySelector(':scope > li:hover > ul.submenu') ||
                 nav.querySelector(':scope > li:focus-within > ul.submenu');
        }

        function openFlyouts(root){
          var seen = [];
          root.querySelectorAll('li:hover > ul.submenu, li:focus-within > ul.submenu').forEach(function(fly){
            if (seen.indexOf(fly) === -1) seen.push(fly);
          });
          return seen;
        }

        function recompute(){
          pending = false;

          // Clear inline heights first so closed panels shrink back and open
          // ones report their natural size.
          nav.querySelectorAll('ul.submenu').forEach(function(el){
            el.style.minHeight = '';
          });

          var root = openRoot();
          if (!root) return;

          var panels = [root].concat(openFlyouts(root));
          var max = 0;
          panels.forEach(function(panel){
            max = Math.max(max, panel.offsetHeight);
          });
          panels.forEach(function(panel){
            panel.style.minHeight = max + 'px';
          });
        }

        function schedule(){
          if (pending) return;
          pending = true;
          requestAnimationFrame(recompute);
        }

        ['mouseover', 'mouseout', 'focusin', 'focusout'].forEach(function(type){
          nav.addEventListener(type, schedule);
        });
      }

      // wait until whole page is loaded
      jQuery(document).ready(function($) {
        setTimeout(
          hoverCardsInit(),
          500
        )
        productCardTapInit();
        primaryNavHeightSync();
      });



        if (document.querySelector('.countup-animated-number')) {
          const animatedNumbers = document.querySelectorAll('.countup-animated-number .number-span');
        
          animatedNumbers.forEach((element) => {
            let targetNumber = parseInt(element.getAttribute('data-target'), 10);
            let delayMs = parseInt(element.getAttribute('data-delay'), 10);
            let startVal = parseInt(element.getAttribute('data-start'), 10) || 0;
        
            let countUp = new CountUp(element, targetNumber, {
              duration: 2,
              separator: ',',
              enableScrollSpy: true,
              scrollSpyOnce: true,
              scrollSpyDelay: 0,
              startVal: startVal,
            });
        
            if (countUp.error) {
              console.error(countUp.error);
            }
          });
        }

        // Airport Carousel
        $('.airport-carousel-wrapper').each(function () {
          var $wrapper = $(this);
          var $track   = $wrapper.find('.airport-carousel-slides');
          var $prev    = $wrapper.find('.carousel-prev');
          var $next    = $wrapper.find('.carousel-next');

          $track.slick({
            centerMode: true,
            arrows: true,
            centerPadding: '0px',
            slidesToShow: 3,
            prevArrow: $prev,
            nextArrow: $next,
            variableWidth: true,
            infinite: true,
            responsive: [
              { breakpoint: 768, settings: { centerMode: true, centerPadding: '40px', slidesToShow: 3 } },
              { breakpoint: 480, settings: { centerMode: true, centerPadding: '40px', slidesToShow: 1 } }
            ]
          });
        });

        //jQuery(function($) {
          // Initialize all carousels
          $('.carousel-wrapper').each(function() {
            var $this = $(this);
            var $slidesToShow = $this.data('slides-to-show');
            var $duration = $this.data('duration');
      
        
            $this.slick({
              infinite: true,
              slidesToShow: $slidesToShow,
              duration: $duration,
              slidesToScroll: 1,
              arrows: true,
              dots: false,
              prevArrow: '<button type="button" class="slick-prev cards-prev"><svg xmlns="http://www.w3.org/2000/svg" width="23" height="41" viewBox="0 0 23 41" fill="none"> <path d="M21.123 1.5L2.12129 20.5018L21.123 39.5035" stroke="#062F6E" stroke-width="3" stroke-linecap="round"/></svg></button>',
              nextArrow: '<button type="button" class="slick-next cards-next"><svg xmlns="http://www.w3.org/2000/svg" width="23" height="41" viewBox="0 0 23 41" fill="none"><path d="M1.5 39.5034L20.5018 20.5017L1.5 1.4999" stroke="#062F6E" stroke-width="3" stroke-linecap="round"/></svg></button>',
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 2,
                  }
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                  }
                },
              ]
            });
          });
        //});

        


        // Panel Display Visualizer
        document.querySelectorAll('.fc-section-screen-compare').forEach(function(block) {
          block.querySelectorAll('.compare-column').forEach(function(column) {

            // Fallback: activate first item if nothing is marked active from PHP
            if (!column.querySelector('.screen-image.active')) {
              const first = column.querySelector('.screen-image');
              if (first) first.classList.add('active');
            }
            if (!column.querySelector('.screen-description.active')) {
              const first = column.querySelector('.screen-description');
              if (first) first.classList.add('active');
            }

            const select = column.querySelector('.screen-options > select');
            if (!select) return;

            select.addEventListener('change', function() {
              const val = select.value;

              column.querySelectorAll('.screen-image').forEach(el => el.classList.remove('active'));
              const activeImg = column.querySelector('.screen-image--' + val);
              if (activeImg) activeImg.classList.add('active');

              column.querySelectorAll('.screen-description').forEach(el => el.classList.remove('active'));
              const activeDesc = column.querySelector('.screen-description--' + val);
              if (activeDesc) activeDesc.classList.add('active');
            });
          });
        });


        // Content Carousel w/ Navigation (arrows): keep the "Slide N of M"
        // counter in sync with the active slide. This lives here — not in the
        // section's inline <script> — because UIkit is bundled in main.min.js
        // and loads in the footer, so window.UIkit is undefined mid-body.
        document.querySelectorAll('.content-carousel-slideshow[uk-slider]').forEach(function(slider){
          var items = slider.querySelector('.content-carousel-slides-navigation');
          if (!items || !items.id) return;

          var counters = document.querySelectorAll(
            '[data-counter-for="' + items.id + '"] .content-carousel-counter__current'
          );
          if (!counters.length) return;

          function setCounter(idx){
            if (idx < 0) return;
            counters.forEach(function(el){ el.textContent = idx + 1; });
          }

          // beforeitemshow fires as navigation is triggered, before the slide
          // transitions in — so the number updates immediately on click. The
          // component index isn't updated yet at this point, so derive it from
          // the incoming item (the event target).
          UIkit.util.on(slider, 'beforeitemshow', function(e){
            setCounter(Array.prototype.indexOf.call(items.children, e.target));
          });

          var comp = UIkit.slider(slider);
          setCounter(comp && typeof comp.index === 'number' ? comp.index : 0);
        });


      },
      finalize: function() {
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS

        var heroWrapper = document.querySelector('.home-hero-content-wrapper');

        if (!heroWrapper) {
            console.error('Hero wrapper not found!');
            return; // Exit if the hero section does not exist
        }
    
        // Calculate the height of the hero section
        var heroHeight = heroWrapper.offsetHeight;
    
        // Adjust this multiplier to control how long the section stays on screen
        var stayMultiplier = .1; 
        var triggerPoint = heroHeight * stayMultiplier;
    
        window.addEventListener('scroll', function () {
            var scrollPosition = window.scrollY;
    
            // Debug: Log scroll position and trigger point
            //console.log('Scroll Position: ' + scrollPosition + ', Trigger Point: ' + triggerPoint);
    
            // Add or remove the "scrolled" class
            if (scrollPosition > triggerPoint) {
                heroWrapper.classList.add('scrolled');
                console.log('Added');
            } else {
                heroWrapper.classList.remove('scrolled');
                console.log('Removed');
            }
        });

      }
    },
    // All Other Pages.
    'page': {
      init: function() {
        
        // Accordion
        $('.accordion-topic').click(function(){
          $(this).next('.accordion-response').slideToggle(500).toggleClass('current');
          $(this).toggleClass('current');
          $(this).parents('.accordion').siblings().find('.accordion-topic').slideUp(500);
          $(this).parents('.accordion').siblings().find('.accordion-response').removeClass('current');
        });
        

      }
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.

// Countdown Timers
document.querySelectorAll('.countdown-timer[data-countdown]').forEach(function(el) {
  var targetStr = el.getAttribute('data-countdown');
  if (!targetStr) return;

  var targetDate = new Date(targetStr.replace(' ', 'T'));
  if (isNaN(targetDate.getTime())) return;

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function tick() {
    var diff = targetDate - new Date();

    if (diff <= 0) {
      var units = el.querySelector('.countdown-units');
      var expired = el.querySelector('.countdown-expired');
      if (units) units.style.display = 'none';
      if (expired) expired.style.display = '';
      return;
    }

    var d = el.querySelector('[data-unit="days"]');
    var h = el.querySelector('[data-unit="hours"]');
    var m = el.querySelector('[data-unit="minutes"]');
    var s = el.querySelector('[data-unit="seconds"]');
    if (d) d.textContent = pad(Math.floor(diff / 86400000));
    if (h) h.textContent = pad(Math.floor((diff % 86400000) / 3600000));
    if (m) m.textContent = pad(Math.floor((diff % 3600000) / 60000));
    if (s) s.textContent = pad(Math.floor((diff % 60000) / 1000));
  }

  tick();
  setInterval(tick, 1000);
});

// Gallery Carousel + Lightbox
jQuery(function($) {
  $('.fc-section-gallery .gallery-carousel').each(function() {
    var $this = $(this);
    var $wrapper = $this.closest('.gallery-carousel-wrapper');
    var $prev = $wrapper.find('.carousel-prev');
    var $next = $wrapper.find('.carousel-next');
    var slidesToShow = parseInt($this.data('slides-to-show'), 10) || 3;
    $this.slick({
      slidesToShow: slidesToShow,
      slidesToScroll: 1,
      infinite: true,
      dots: false,
      arrows: true,
      prevArrow: $prev.length ? $prev : undefined,
      nextArrow: $next.length ? $next : undefined,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: Math.min(slidesToShow, 2) } },
        { breakpoint: 768,  settings: { slidesToShow: 1 } }
      ]
    });
  });

  // Slick clones slides for infinite mode; route cloned-anchor clicks to the
  // matching original so the lightbox still opens and the browser doesn't navigate away.
  $('.fc-section-gallery').on('click', '.slick-cloned [data-lightbox]', function(e) {
    e.preventDefault();
    var href = this.getAttribute('href');
    var $original = $(this).closest('.fc-section-gallery')
      .find('.slick-slide:not(.slick-cloned) [data-lightbox]')
      .filter(function() { return this.getAttribute('href') === href; })
      .first();
    if ($original.length) $original.get(0).click();
  });

  $('.fc-section-gallery').each(function () {
    var $links = $(this).find('[data-lightbox]').filter(function() {
      return !$(this).closest('.slick-cloned').length;
    });
    if ($links.length) {
      new SimpleLightbox($links.get());
    }
  });
});

// Quantity stepper: +/- buttons on single-product quantity input
jQuery(function($) {
  $(document).on('click', '.uav-qty-stepper .uav-qty-btn', function(e) {
    e.preventDefault();
    var $btn   = $(this);
    var $input = $btn.closest('.uav-qty-stepper').find('input.qty');
    if (!$input.length || $input.prop('readonly')) return;

    var step = parseFloat($input.attr('step')) || 1;
    var min  = parseFloat($input.attr('min'));
    var max  = parseFloat($input.attr('max'));
    var val  = parseFloat($input.val()) || 0;

    val += $btn.hasClass('uav-qty-plus') ? step : -step;
    if (!isNaN(min) && val < min) val = min;
    if (!isNaN(max) && val > max) val = max;

    $input.val(val).trigger('change');
  });
});

// Product Package: Purchase Package handler
jQuery(function($) {
  $(document).on('click', '.add-all-to-cart', function(e) {
    e.preventDefault();

    var $button = $(this);
    var productIds = [];
    var quantities = [];

    if ($button.hasClass('is-loading')) return;

    $button.closest('.fc-section-product-package').find('.card-cell-product').each(function() {
      var productId = $(this).data('product-id');
      if (productId) {
        productIds.push(productId);
        quantities.push(1);
      }
    });

    if (!productIds.length) return;

    $button.html('<i class="fa-regular fa-sync fa-spin-snap"></i> Adding to cart…').addClass('is-loading');
    $button.css('pointer-events', 'none'); // Disable pointer events while loading

    $.post(window.uavionix_ajax && window.uavionix_ajax.url ? window.uavionix_ajax.url : '/wp-admin/admin-ajax.php', {
      action: 'add_multiple_products_to_cart',
      product_ids: productIds,
      quantities: quantities
    }, function(response) {
      if (!response || !response.success) {
        console.error('Product Package: add to cart failed', response && response.data);
        $button.text('Error - try again').removeClass('is-loading');
        return;
      }
      var cartUrl = window.uavionix_ajax && window.uavionix_ajax.cart_url ? window.uavionix_ajax.cart_url : '/cart/';
      $button.text('Added!').removeClass('is-loading');
      $button.css('pointer-events', 'all'); // Re enable pointer events 
      window.location.href = cartUrl;
    }).fail(function() {
      console.error('Product Package: add to cart request failed');
      $button.text('Error - try again').removeClass('is-loading');
      $button.css('pointer-events', 'all'); // Re enable pointer events 
    });
  });
});

